export enum RequestStatus {
  NOT_STARTED = "NOT_STARTED",
  REQUESTING = "REQUESTING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export type RemoteData<Result> =
  | { type: RequestStatus.NOT_STARTED }
  | { type: RequestStatus.REQUESTING }
  | { type: RequestStatus.SUCCESS; result: Result }
  | { type: RequestStatus.FAILURE; reason: string };
